package com.wintermar.inspection.core.ui.theme.color.palette.accent

import androidx.compose.ui.graphics.Color
import com.wintermar.inspection.core.ui.theme.color.model.ColorVariant

val LimeColorVariant = ColorVariant(
    n100 = Color(0xFFEFFFD6),
    n200 = Color(0xFFD3F1A7),
    n300 = Color(0xFFB3DF72),
    n400 = Color(0xFF94C748),
    n500 = Color(0xFF82B536),
    n600 = Color(0xFF6A9A23),
    n700 = Color(0xFF5B7F24),
    n800 = Color(0xFF4C6B1F),
    n900 = Color(0xFF37471F),
    n1000 = Color(0xFF28311B)
)
